import React, { useState, useEffect } from "react";
import MainCalculatorsList from "../FoodCalculator/MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";

const TITLE = "Calculatrice Crème Glacée - Calcul Recette Crème Glacée Maison";
const DESCRIPTION =
  "Calculatrice Crème Glacée - Calcul Recette Crème Glacée Maison pour adapter vos recettes, portions et conversions en cuisine. Resultat rapide et pratique pour cuisiner avec plus de precision chaque jour.";
const KEYWORDS =
  "crème glacée calcul recette crème glacée maison, calculatrice crème glacée calcul recette crème glacée maison, calcul en ligne, cuisine, recette, conversion, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/ice-cream/";

const SCHEMA = [
  {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    name: "Calculatrice Crème Glacée",
    description: DESCRIPTION,
    url: OG_URL,
    applicationCategory: "UtilityApplication",
    operatingSystem: "Any",
    offers: {
      "@type": "Offer",
      price: "0",
      priceCurrency: "USD",
    },
  },
];

function IceCreamCalculator() {
  const [totalWeight, setTotalWeight] = useState(1000);
  const [fatPercent, setFatPercent] = useState(10);
  const [msnfPercent, setMsnfPercent] = useState(10.5);
  const [sugarPercent, setSugarPercent] = useState(15);
  const [stabilizerPercent, setStabilizerPercent] = useState(0.5);

  const [result, setResult] = useState(null);
  const [error, setError] = useState("");

  const calculateIceCream = () => {
    try {
      setError("");

      const weight = parseFloat(totalWeight);
      const fatP = parseFloat(fatPercent);
      const msnfP = parseFloat(msnfPercent);
      const sugarP = parseFloat(sugarPercent);
      const stabP = parseFloat(stabilizerPercent);

      if (weight <= 0 || fatP < 0 || msnfP < 0 || sugarP < 0 || stabP < 0) {
        setError("Veuillez entrer des valeurs correctes supérieures à zéro");
        setResult(null);
        return;
      }

      if (fatP + msnfP + sugarP + stabP >= 100) {
        setError("La somme des pourcentages de composants solides doit être inférieure à 100%");
        setResult(null);
        return;
      }

      const fatWeight = (weight * fatP) / 100;
      const msnfWeight = (weight * msnfP) / 100;
      const sugarWeight = (weight * sugarP) / 100;
      const stabilizerWeight = (weight * stabP) / 100;
      const waterWeight = weight - (fatWeight + msnfWeight + sugarWeight + stabilizerWeight);

      const totalSolids = fatP + msnfP + sugarP + stabP;

      setResult({
        fatWeight,
        msnfWeight,
        sugarWeight,
        stabilizerWeight,
        waterWeight,
        totalSolids,
        batchSize: weight
      });
    } catch (err) {
      setError("Erreur en Calcul. Vérifiez que vous avez entré des nombres valides.");
      setResult(null);
    }
  };

  useEffect(() => {
    calculateIceCream();
  }, [totalWeight, fatPercent, msnfPercent, sugarPercent, stabilizerPercent]);

  const handleClear = () => {
    setTotalWeight(1000);
    setFatPercent(10);
    setMsnfPercent(10.5);
    setSugarPercent(15);
    setStabilizerPercent(0.5);
    setResult(null);
    setError("");
  };

  return (
    <div className="ltr" style={{ direction: "ltr" }}>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
        SCHEMA={SCHEMA}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ padding: "15px", borderRadius: "5px" }}
          >
            <h1 style={{ fontSize: "22px", margin: 0 }}>Calculatrice Crème Glacée</h1>
          </div>
          <div className="border border-light mt-3 p-3 bg-white shadow-sm">
            <div className="mb-4">
              <p style={{ fontSize: "16px", lineHeight: "1.8" }}>
                La <strong>calculatrice crème glacée</strong> vous aide à équilibrer les ingrédients du mélange glacé pour obtenir une texture professionnelle. 
                La qualité de la crème glacée dépend de l'équilibre précis entre graisses, sucres et solides de lait (MSNF) pour éviter les cristaux de glace et assurer une texture lisse.
              </p>
            </div>
            <hr />
            <MobileUnderCalAds />

            <div className="calculatorStyle mb-4">
              <div className="p-3 mb-3 bg-success text-white text-center rounded">
                <h2 style={{ fontSize: "18px", margin: 0 }}>Données Mélange Crème Glacée</h2>
              </div>

              <div className="row">
                <div className="col-sm-12 col-md-6 mb-3">
                  <label >Quantité Totale Mélange (grammes)</label>
                  <input
                    type="number"
                    className="form-control"
                    value={totalWeight}
                    onChange={(e) => setTotalWeight(e.target.value)}
                  />
                </div>
                <div className="col-sm-12 col-md-6 mb-3">
                  <label >Pourcentage Graisses Cible (%)</label>
                  <input
                    type="number"
                    className="form-control"
                    value={fatPercent}
                    onChange={(e) => setFatPercent(e.target.value)}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-sm-12 col-md-4 mb-3">
                  <label >Pourcentage Sucre (%)</label>
                  <input
                    type="number"
                    className="form-control"
                    value={sugarPercent}
                    onChange={(e) => setSugarPercent(e.target.value)}
                  />
                </div>
                <div className="col-sm-12 col-md-4 mb-3">
                  <label >Pourcentage MSNF (%)</label>
                  <input
                    type="number"
                    className="form-control"
                    value={msnfPercent}
                    onChange={(e) => setMsnfPercent(e.target.value)}
                  />
                </div>
                <div className="col-sm-12 col-md-4 mb-3">
                  <label >Stabilisants / Émulsifiants (%)</label>
                  <input
                    type="number"
                    className="form-control"
                    value={stabilizerPercent}
                    onChange={(e) => setStabilizerPercent(e.target.value)}
                  />
                </div>
              </div>

              <div className="text-center mb-3 mt-4">
                <button
                  onClick={handleClear}
                  className="btn btn-secondary"
                  style={{ fontSize: "16px", padding: "10px 30px" }}
                >
                  Effacer Les Données
                </button>
              </div>

              {error && (
                <div className="alert alert-warning" role="alert">
                  {error}
                </div>
              )}

              {result && (
                <div className="mt-4">
                  <h3 style={{ fontSize: "18px", marginBottom: "15px", textAlign: "center" }}>
                    <strong>Résultats Requis pour la Recette :</strong>
                  </h3>
                  <div className="mb-3">
                    <table className="table bmi-table" style={{ width: "100%" }}>
                      <thead>
                        <tr>
                          <th className="bmi-header" style={{ textAlign: "center" }}>Ingrédient</th>
                          <th className="bmi-header" style={{ textAlign: "center" }}>Poids (grammes)</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td style={{ textAlign: "center" }}>Graisses Nettes</td>
                          <td style={{ textAlign: "center", fontWeight: "bold" }}>{result.fatWeight.toFixed(2)}</td>
                        </tr>
                        <tr>
                          <td style={{ textAlign: "center" }}>Solides Non Gras (MSNF)</td>
                          <td style={{ textAlign: "center", fontWeight: "bold" }}>{result.msnfWeight.toFixed(2)}</td>
                        </tr>
                        <tr>
                          <td style={{ textAlign: "center" }}>Sucre</td>
                          <td style={{ textAlign: "center", fontWeight: "bold" }}>{result.sugarWeight.toFixed(2)}</td>
                        </tr>
                        <tr>
                          <td style={{ textAlign: "center" }}>Stabilisants</td>
                          <td style={{ textAlign: "center", fontWeight: "bold" }}>{result.stabilizerWeight.toFixed(2)}</td>
                        </tr>
                        <tr>
                          <td style={{ textAlign: "center" }}>Liquides (Eau/Lait Liquide)</td>
                          <td style={{ textAlign: "center", fontWeight: "bold", color: "#1a5f3f" }}>{result.waterWeight.toFixed(2)}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Conseils d'utilisation</h3></div>
              <div className="info-section-body">
                <p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p>
              </div>
            </div>
                    <div className="info-section">
                      <div className="info-section-header">Analyse Texture</div>
                      <div className="info-section-body">
                        <ul style={{ listStyle: "none", padding: 0, lineHeight: "2" }}>
                          <li>🍦 <strong>Solides Totaux :</strong> {result.totalSolids.toFixed(2)}%</li>
                          <li>💧 <strong>Pourcentage Eau :</strong> {(100 - result.totalSolids).toFixed(2)}%</li>
                        </ul>
                        <div className="alert alert-info mt-2" style={{ fontSize: "14px" }}>
                          Le pourcentage idéal de solides totaux se situe entre 36% et 42% pour la meilleure texture.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
            </div>
          </div>
        </div>
        <div className="col-sm-12 col-md-4">
          <SecondAds />
          <br />
          <MainCalculatorsList />
        </div>
      </div>
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>Faire sa crème glacée maison</h3>
              </div>
              <div className="info-section-body">
                <p>
                  La crème glacée maison, c'est avant tout une question d'équilibre entre les matières grasses, le sucre et l'eau. Trop d'eau (comme dans le lait écrémé)
                  donne une texture pleine de cristaux de glace. Trop de sucre et la crème ne fige pas bien. La clé est d'avoir entre 36 et 42 % de solides totaux dans
                  votre mélange — ce que cette calculatrice mesure automatiquement. Plus le pourcentage est élevé, plus la texture sera onctueuse et crémeuse.
                </p>
                <ul>
                  <li>Utiliser de la crème entière (30-35 % de matières grasses) pour un résultat riche</li>
                  <li>Le lait concentré sucré remplace avantageusement le sucre + lait dans les recettes sans sorbetière</li>
                  <li>Les jaunes d'œufs agissent comme émulsifiants et améliorent la texture</li>
                  <li>Une cuillère de maïzena ou de stabilisant réduit la formation de cristaux</li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>Proportions selon le type de crème glacée</h3>
              </div>
              <div className="info-section-body">
                <p>
                  Les recettes varient selon le style recherché. Une crème glacée française (à base de crème anglaise) est plus riche en jaunes d'œufs et en matières grasses.
                  Le gelato italien utilise plus de lait que de crème, ce qui lui donne une texture plus dense. Le sorbet, lui, ne contient pas de produits laitiers — seulement
                  du fruit, du sucre et de l'eau.
                </p>
                <ul>
                  <li>Crème glacée américaine : 2 parts crème + 1 part lait + sucre (environ 15-20 %)</li>
                  <li>Gelato : 3 parts lait + 1 part crème + jaunes d'œufs</li>
                  <li>Frozen yogurt : yaourt entier + sucre + stabilisant</li>
                  <li>Sorbet : purée de fruit (60 %) + sirop de sucre (40 %)</li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>Conseils de conservation et de service</h3>
              </div>
              <div className="info-section-body">
                <p>
                  La crème glacée maison se conserve bien au congélateur mais a tendance à durcir plus que les versions industrielles (qui contiennent des stabilisants).
                  Sortez-la 5 à 10 minutes avant de servir pour qu'elle ramollisse et développe toute sa saveur. Conservez-la dans un récipient hermétique avec un film alimentaire
                  directement en contact avec la surface pour éviter les cristaux de glace.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default IceCreamCalculator;
